var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3692 14.1432L20.5538 8.96998C19.0974 7.67667 16.9026 7.67667 15.4462 8.96998L9.63077 14.1432C8.59487 15.067 8 16.3911 8 17.787V23.1245C8 25.8137 10.1846 28 12.8718 28H23.1282C25.8154 28 28 25.8137 28 23.1245V17.787C28 16.3911 27.4051 15.067 26.3692 14.1432ZM26.4615 23.1245C26.4615 24.9618 24.9641 26.4604 23.1282 26.4604H12.8718C11.0359 26.4604 9.53846 24.9618 9.53846 23.1245V17.787C9.53846 16.8324 9.94872 15.9292 10.6564 15.2928L16.4615 10.1196C16.9026 9.72954 17.4462 9.53451 18 9.53451C18.5538 9.53451 19.0974 9.72954 19.5385 10.1196L25.3436 15.2928C26.0513 15.9292 26.4615 16.8324 26.4615 17.787V23.1245Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2105 22.5H13.7895C13.3579 22.5 13 22.84 13 23.25C13 23.66 13.3579 24 13.7895 24H22.2105C22.6421 24 23 23.66 23 23.25C23 22.84 22.6421 22.5 22.2105 22.5Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.4adb5465.svg";
export { ForwardRef as ReactComponent };